import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
} from "@angular/core"; // MOD INE(JJGJ) 20231010 REQ25710 ADD Renderer2,ViewChild
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../../../seguridad/services/seguridad.service';
import { RoutesMap } from '../../routes.const';
import { CreditoService } from '../../../credito/services/credito.service';//INE INE(PVR) REQ25710 20240215
import { AuditoriaNavegacionClass } from '../../../core/funciones/auditoria';//INE INE(PVR) REQ25710 20240405
import { AuditoriaService } from '../../../seguridad/services/auditoria.service';//INE INE(PVR) REQ25710 20240405

declare var $: any;
@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],
  providers: [SeguridadService,CreditoService,AuditoriaService]//INE INE(PVR) REQ25710 20240215
})
export class MenuComponent implements OnInit {
  public isClassVisible: false;
  public model: any = {};
  public perfil : string;
  private liopcionesCredito =
  [
    // {ref: '/credito', li: 'Lista de crédito' },
    {ref: '/credito', li: 'Detalle de Créditos' },
    {ref: '/credito/cronograma', li: 'Cronograma de Pagos' },
    {ref: '/credito/estadoCuenta', li: 'Estado de Cuenta' },
    {ref: '/credito/impuestoVehicular', li: 'Impuesto Vehicular' },
    {ref: '/credito/actualizar', li: 'Actualizar Datos' } //ADD INE(EGB) 20220709 - REQ22111
  ];
  public showMenuSeguro :boolean = false; //ADD INE(JJGJ) 20221018 - REQ22978
  public showMenuTramites :boolean = false; //ADD INE(JJGJ) 20221018 - REQ22978
  private TieneprestamoPreAprobado: boolean = false;//INE INE(PVR) REQ25710 20240215
  private modulo = 'Menu'; //INE INE(PVR) REQ25710 20240405
   // INI INE(JJGJ) 20231010 REQ25710
  @ViewChild("buttonIcon") buttonIcon: ElementRef;
  @ViewChild("menu") menu: ElementRef;
  @ViewChild("submenuCreditos") submenuCreditos: ElementRef;
  @ViewChild("submenuObtenCredito") submenuObtenCredito: ElementRef;
  @ViewChild("submenuTramites") submenuTramites: ElementRef;
  private HEIGHT_ITEM_MENU: number = 38;
  // FIN INE(JJGJ) 20231010 REQ25710
  constructor(private seguridadService: SeguridadService, private router: Router ,private renderer2: Renderer2, private CreditoService: CreditoService, private auditoriaService: AuditoriaService){}   // ADD INE(JJGJ) 20231010 REQ25710) { }//INE INE(PVR) REQ25710 20240215

  ngOnInit() {
    const me = this;
    me.model.usuario = JSON.parse(localStorage.getItem('objSesionUsuarioLogeado'));
    this.perfil = me.model.usuario.perfil;
    this.ObtenerCreditoPersonalPreApobado();//INE(PVR) REQ25710 20240215
  }
  refresh(): void {
    const me = this;
      if (this.perfil == 'Cliente') {
          if (this.router.url === '/credito/lista') {
   
          } else {
              localStorage.removeItem('objTargetCredito');
          }
          me.router.navigate(['./' + RoutesMap.LISTA_CREDITO]);
      
    }
    if(this.perfil=='Administrador'){
      me.router.navigate(['./'+ RoutesMap.ADMINISTRACION]);
    }
   // window.location.reload();
}

  onCerrarSesion(){
    const me = this;
    let _cerrarSesionClienteRequest: {
      IdUsuario: number;
    };

    _cerrarSesionClienteRequest = {
      IdUsuario : me.model.usuario.idusuario
    }

    this.seguridadService.cerrarSesionCliente(_cerrarSesionClienteRequest).then(res => {
      if(res!=null){
        let satisfactorio:boolean = res.data.satisfactorio;
        if(satisfactorio){
          localStorage.clear();
          const me = this;
          me.router.navigate(['/']);
        }
      }
    }).catch(err => {
      if (err.status === 401) {
        $('#incorrectos_error').show();
      }
      console.log(err);
    });
  }
  /*  INI - INE(JJGJ) 20230922 - REQ24688  */

  showMenu(e: any) {
    console.log(e.target.parentNode.dataset.target);
    if (document.querySelector(e.target.parentNode.dataset.target)) {
      document
        .querySelector(e.target.parentNode.dataset.target)
        .classList.toggle("collapse");
    }
  }

  /*  FIN - INE(JJGJ) 20230922 - REQ24688  */
//INI INE(JJGJ) 20231010 REQ25710
  changeMenu(e: any) {
    const button_icon = this.buttonIcon.nativeElement;
    const menu = this.menu.nativeElement;
    const childs: number = menu.childElementCount;
    if (button_icon.classList.contains("show")) {
      this.renderer2.removeClass(button_icon, "show");
    } else {
      this.renderer2.addClass(button_icon, "show");
    }
    if (menu.clientHeight > 0) {
      this.renderer2.setStyle(menu, "height", "0px");
    } else {
      this.renderer2.setStyle(
        menu,
        "height",
        String(childs * this.HEIGHT_ITEM_MENU) + "px"
      );
    }
  }
  showSubMenuCreditos() {
    this.changeSubMenu(this.submenuCreditos.nativeElement);
  }
  showSubMenuTramites() {
    this.changeSubMenu(this.submenuTramites.nativeElement);
  }
  //INI INE(PVR) REQ25710 20240215
  showSubMenuObtenCredito() {
    if (!this.TieneprestamoPreAprobado) 
      this.navigateByUrl('Menú - Obtén tu crédito','Obtén tu crédito - Crédito Vehicular','/credito/creditovehicular')
    this.changeSubMenu(this.submenuObtenCredito.nativeElement);
  }
  
  navigateByUrl(Modulo: string, Opcion: string, Ruta: string, Mensaje: string = ''){    
    new AuditoriaNavegacionClass(this.auditoriaService)
    .guardarAuditoriaNavegacion(this.model.usuario.idusuario,
      Modulo,
      Opcion,
      'Click - ' + Opcion,
      Mensaje);
      
      this.router.navigateByUrl(Ruta);
  }
  //FIN INE(PVR) REQ25710 20240215

  private changeSubMenu(submenu: any) {
    if (screen.width < 768) {
      const menu = this.menu.nativeElement;
      const childsSubmenu: number = submenu.childElementCount;
      if (submenu.clientHeight > 0) {
        this.renderer2.setStyle(submenu, "height", "0px");
        this.renderer2.setStyle(
          menu,
          "height",
          "calc(" +
            String(menu.style.height) +
            " - " +
            String(childsSubmenu * this.HEIGHT_ITEM_MENU) +
            "px)"
        );
      } else {
        this.renderer2.setStyle(
          submenu,
          "height",
          String(childsSubmenu * this.HEIGHT_ITEM_MENU) + "px"
        );
        this.renderer2.setStyle(
          menu,
          "height",
          "calc(" +
            String(menu.style.height) +
            " + " +
            String(childsSubmenu * this.HEIGHT_ITEM_MENU) +
            "px)"
        );
      }
    }
  }
  //FIN INE(JJGJ) 20231010 REQ25710
  //INE INE(PVR) REQ25710 20240215
  ObtenerCreditoPersonalPreApobado() {
    let Usuario = JSON.parse(localStorage.getItem('objSesionUsuarioLogeado') );
    let ObtenerCreditoPersonal = {
      IdUsuario: Usuario.idusuario,
      NumDocumento: Usuario.NroDocumento
    };

    this.CreditoService
      .ObtenerCreditoPersonalPreApobado(ObtenerCreditoPersonal)
      .then(res => {
        if (res.data != null) {
          if (res.data.length > 0) {
            this.TieneprestamoPreAprobado = true;
            this.renderer2.setStyle(this.submenuObtenCredito.nativeElement, "display", "flex");
          } else {
            this.TieneprestamoPreAprobado = false;
            this.renderer2.setStyle(this.submenuObtenCredito.nativeElement, "display", "none"); 
          }
        }
      })
      .catch(err => {
        console.log(err);
      });
  }
  onMenuItemClick(event: MouseEvent) {
    const clickedElement = event.target as HTMLElement;
    const listItem = this.findClosestListItem(clickedElement);

    if (listItem) {
      // Remover la clase de todos los elementos <li> dentro de <ul>
      const menuItems = this.menu.nativeElement.querySelectorAll('A');
      menuItems.forEach(item => {
        item.classList.remove('link__menu__select');
      });

      // Agregar la clase al elemento <li> más cercano al clickeado
      listItem.classList.add('link__menu__select');

      console.log('Elemento clickeado:', listItem.textContent.trim());
      // Aquí puedes realizar cualquier acción adicional que desees con el elemento clickeado
    }
  }

  private findClosestListItem(element: HTMLElement): HTMLElement | null {
    while (element.tagName !== 'A' && element !== this.menu.nativeElement) {
      element = element.parentElement;
    }

    if (element.tagName === 'A') {
      return element;
    } else {
      return null;
    }
  }   
//FIN INE(PVR) REQ25710 20240215
}
